var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pl-0 text-cta",attrs:{"color":"#db0812","disabled":_vm.disabled,"text":"","small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.copy))])}
var staticRenderFns = []

export { render, staticRenderFns }